import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia?',
  answer: <span data-id="element-48">
        No. Está explicado desde cero y con pasos claros.{' '}
        <strong data-id="element-49">Empiezas con una cuenta anónima sin improvisar</strong>.
      </span>
}, {
  question: '¿De verdad no tengo que mostrar mi cara?',
  answer: <span data-id="element-50">
        Correcto. <strong data-id="element-51">No mostrar tu cara</strong> es el punto. Te damos
        alternativas faceless para crear estética, contenido y confianza sin
        exponerte.
      </span>
}, {
  question: '¿Cuánto tiempo necesito?',
  answer: <span data-id="element-52">
        Para empezar: 2–4 horas la primera semana. Después:{' '}
        <strong data-id="element-53">20–30 min al día</strong> para mantener constancia sin agobio.
      </span>
}, {
  question: '¿Sirve para cualquier nicho?',
  answer: <span data-id="element-54">
        Sí. La metodología se adapta.{' '}
        <strong data-id="element-55">
          Funciona mejor en nichos donde hay un problema y una solución clara
        </strong>{' '}
        (y te damos ejemplos).
      </span>
}, {
  question: '¿Cómo lo recibo?',
  answer: <span data-id="element-56">
        Tras el pago, recibes el acceso por email.{' '}
        <strong data-id="element-57">Acceso inmediato</strong> y descarga directa.
      </span>
}, {
  question: '¿Es solo un PDF?',
  answer: <span data-id="element-58">
        Es un <strong data-id="element-59">pack digital descargable</strong>: guía + checklist +
        guiones listos para aplicar. Está diseñado para que implementes desde el
        primer día.
      </span>
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 bg-alt" data-id="element-60">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <h2 className="text-3xl font-serif text-center text-title mb-12" data-id="element-62">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-63">
          {faqs.map((faq, index) => <div key={index} className="bg-card border border-[#D9D0C1] overflow-hidden" data-id="element-64">
              <button className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-65">
                <span className={`font-medium ${openIndex === index ? 'text-accent' : 'text-title'}`} data-id="element-66">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus size={20} className="text-accent" data-id="element-67" /> : <Plus size={20} className="text-body" data-id="element-68" />}
              </button>

              <div className={`px-6 text-body text-sm transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 py-4 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-69">
                {faq.answer}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}